import { render } from "./InternalServerError.vue?vue&type=template&id=394b61b5"
import script from "./InternalServerError.vue?vue&type=script&lang=js"
export * from "./InternalServerError.vue?vue&type=script&lang=js"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__